import { toast } from "react-toastify";
import callApi from "./CallApi";

export const handleDelete = (id, callbackApi, cb) => {
  if (!id || !callbackApi) return;
  callApi({
    callback: callbackApi,
    payload: id,
    onSuccess: ({ message }) => {
      toast.error(message || "Record deleted successfully");
      if (cb) {
        cb((prev) => ({
          ...prev,
          data: prev.data.filter((item) => item.id !== id),
        }));
      }
    },
    onError: () => {
      toast.error("Something went wrong");
    },
  });
};
export const handleStatusChange = (id, status, callbackApi, cb) => {
  if (!id || !callbackApi || !status) return;
  callApi({
    callback: callbackApi,
    payload: [id, status],
    onSuccess: ({ message }) => {
      toast.success(message || "Status updated successfully");
      if (cb) {
        cb((prev) => ({
          ...prev,
          data: prev.data.map((item) =>
            item.id === id ? { ...item, ...status } : item
          ),
        }));
      }
    },
    onError: () => {
      toast.error("Something went wrong");
    },
  });
};
